import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { IErrorLogBaseWithId } from 'src/types'

import { useStyles } from './styles'
import { ErrorLogIcon } from 'src/assets/icons/v2/ErrorLogIcon'
import { ScriptIcon } from 'src/assets/icons/v2/ScriptIcon'
import { WorldIcon } from 'src/assets/icons/v2/WorldIcon'
import { EmptyUserIcon } from 'src/assets/icons/v2/EmptyUserIcon'

interface IErorrLogFormModalProps {
  open: boolean
  handleClose: () => void
  formValues: IErrorLogBaseWithId | null
}

const ErrorLogFormModal = ({ open, handleClose, formValues }: IErorrLogFormModalProps) => {
  const classes = useStyles()

  if (!formValues) {
    return null
  }

  let values: [string, any][] | null = null
  try {
    values = Object.entries(JSON.parse(formValues.details))
  } catch {}

  return (
    <ModalWrapper open={open} className={classes.modalWrapper} onClose={handleClose}>
      <div className={classes.tableHeader}>
        <ErrorLogIcon size={80} />
        <Typography className={classes.title}>
          <HelperWrapper t="error-logs-header-title" />
        </Typography>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell width="20%" align="center">
                <HelperWrapper t="error-logs-field-column" />
              </TableCell>
              <TableCell width="60%" align="center">
                <HelperWrapper t="error-logs-value-column" />
              </TableCell>
              <TableCell width="20%" align="center" />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell width="20%" align="center">
                <div className={classes.cellDisplay}>
                  <ScriptIcon size={20} />
                  <div>Message:</div>
                </div>
              </TableCell>
              <TableCell width="60%">{formValues.message || <EmptyUserIcon size={24} />}</TableCell>
              <TableCell width="20%" align="center" />
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <div className={classes.cellDisplay}>
                  <WorldIcon size={20} />
                  <div>Method:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.method || <EmptyUserIcon size={24} />}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row" />
              <TableCell>
                {values!.map(([key, val]) => {
                  return (
                    <div className={classes.codeWrapper}>
                      <p className={classes.keyStyle}>"{key}":</p>
                      <p className={classes.valStyle}>
                        "{typeof val === 'object' ? JSON.stringify(val) : val.toString()}"
                      </p>
                    </div>
                  )
                })}
              </TableCell>
              <TableCell component="th" scope="row" />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </ModalWrapper>
  )
}

function transformValue(val: unknown) {
  switch (typeof val) {
    case 'string':
      return val
    default:
      return JSON.stringify(val)
  }
}

export { ErrorLogFormModal }
